import React from 'react';
import styled from 'styled-components';
import responsive from '../../../../styles/responsive';
import BookTitle from './BookTitle';

const Wrapper = styled.div`
  width: calc(50% - 9.2rem);
  height: 100%;
  display: flex;
  align-items: center;

  ${responsive.conditionForOnlyOneSideView} {
    width: 50%;
  }
  ${responsive.conditionForMobile} {
    width: 35%;
  }
`;

function LeftSide() {
  return (
    <Wrapper>
      <BookTitle />
    </Wrapper>
  );
}

export default LeftSide;
